import { render, staticRenderFns } from "./DonationOrder.vue?vue&type=template&id=2b631ff0&scoped=true"
import script from "./DonationOrder.vue?vue&type=script&lang=js"
export * from "./DonationOrder.vue?vue&type=script&lang=js"
import style0 from "./DonationOrder.vue?vue&type=style&index=0&id=2b631ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b631ff0",
  null
  
)

export default component.exports